import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Container, Row, Col, Image, Carousel, Stack } from 'react-bootstrap';
import { useRecoilValue } from 'recoil';
import Footer from '../../component/Footer';
import Header from '../../component/header';
import Bronze from '../../assets/bronze.png';
import Silver from '../../assets/silver.png';
import Gold from '../../assets/gold.png';
import Platinum from '../../assets/platinum.png';
import Black from '../../assets/black.png';
import '../../css/m_newMain.css';
import {
	languageSetting,
	translatedText,
} from '../../recoil-states/language-state';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import { useAccount } from 'wagmi';
import ShillaGalleryDetail from '../../component/detailModal/ShillaGalleryModal';
import { getTTFB } from 'web-vitals';
import { huobi_closing_price } from '../../recoil-states/huobi-api';
import { _formatPrice } from '../../function/functions';

const M_newMain = ({ handleAuth }) => {
	const textData = useRecoilValue(translatedText);
	const history = useHistory();
	const lang = useRecoilValue(languageSetting);
	const [openModal, setOpenModal] = useState(null);
	const [huobiPrice, setHuobiPrice] = useState(null);

	const whiteAreaRef = useRef([]);
	const mobileHeaderRef = useRef(null);
	const options = mobileHeaderRef.current && {
		root: mobileHeaderRef?.current,
	};
	const HeaderObserver = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) {
				mobileHeaderRef?.current?.classList.add('active');
			} else if (entry.intersectionRatio > 0) {
				mobileHeaderRef?.current?.classList.remove('active');
			}
		});
	});

	const _houbiApiTime = async () => {
		let apiTime = await huobi_closing_price();
		let apiData = apiTime && apiTime.results.kctusdt.price;

		setHuobiPrice(apiData);
	};

	useEffect(() => {
		_houbiApiTime();
	}, []);

	useEffect(() => {
		if (whiteAreaRef.current) {
			HeaderObserver.observe(whiteAreaRef.current);
		}
	}, [whiteAreaRef.current]);

	const { isConnected } = useAccount();
	/**
	 * 선택된 모달 열고닫음
	 * @function onModal
	 */
	const onModal = _card => {
		switch (_card) {
			case 'Shilla':
				setOpenModal(1);
				break;
		}
	};

	const openModalPackage = () => {
		switch (openModal) {
			case 1:
				return (
					<ShillaGalleryDetail
						setOpenModal={setOpenModal}
						view={false}
					/>
				);
		}
	};

	const joinAction = () => {
		if (isConnected) {
			alert(textData?.gallery['Comming Soon']);
		} else {
			handleAuth();
		}
	};

	const membershipStandard = [
		{
			grade: 5,
			level: 'bronze',
			kct: 100 / huobiPrice,
			usdt: '100',
			img: Bronze,
		},
		{
			grade: 4,
			level: 'silver',
			kct: 5000 / huobiPrice,
			usdt: '5,000',
			img: Silver,
		},
		{
			grade: 3,
			level: 'gold',
			kct: 30000 / huobiPrice,
			usdt: '30,000',
			img: Gold,
		},
		{
			grade: 2,
			level: 'black',
			kct: 80000 / huobiPrice,
			usdt: '80,000',
			img: Black,
		},
		{
			grade: 1,
			level: 'platinum',
			kct: 400000 / huobiPrice,
			usdt: '400,000',
			img: Platinum,
		},
	];

	const membershipContent = [
		{
			id: 1,
			mainText: textData?.mobileMembershipUsing.join,
			subText: textData?.mobileMembershipDetail.join,
		},
		{
			id: 2,
			mainText: textData?.mobileMembershipUsing.cardSelect,
			subText: textData?.mobileMembershipDetail.cardSelect,
		},
		{
			id: 3,
			mainText: textData?.mobileMembershipUsing.usecard,
			subText: textData?.mobileMembershipDetail.usecard,
		},
	];

	const tier1 = membershipStandard.slice(3, 5);
	const tier2 = membershipStandard.slice(0, 3);

	return (
		<>
			{openModalPackage()}
			<Header ref={mobileHeaderRef} handleAuth={handleAuth} />
			<Container fluid className='m_main_container'>
				<div ref={whiteAreaRef} className='whiteArea'>
					<Carousel controls={false} fade={true}>
						<Carousel.Item>
							<Row className='m_main_box'>
								<Col lg={12} className='m_main_box_text'>
									{lang === 'ko' ? (
										<Col>
											<p>
												{
													textData?.mobileMain
														.carousel1_subText
												}
											</p>
										</Col>
									) : null}
									<Col
										style={{
											marginBottom:
												lang === 'ko' ? '2.4rem' : null,
										}}>
										<h1
											style={{
												fontSize:
													lang === 'en'
														? '2.5rem'
														: '2.8rem',
											}}>
											{
												textData?.mobileMain
													.carousel1_mainText1
											}
										</h1>
										<h1
											style={{
												fontSize:
													lang === 'en'
														? '2.5rem'
														: '2.8rem',
											}}>
											{
												textData?.mobileMain
													.carousel1_mainText2
											}
										</h1>
									</Col>
									{lang === 'en' ? (
										<Col>
											<p
												style={{
													fontSize: '1.6rem',
													textAlign: 'center',
													marginBottom: '2.2rem',
												}}>
												Connect the amazing benefits
												<br />
												and new experiences
											</p>
										</Col>
									) : null}
									<Col
										lg={12}
										sm={12}
										xs={12}
										className='m_main_box_bottom'
										style={{ marginBottom: '2.5rem' }}>
										<img
											src={require('../../assets/mobile_assets/main_membership.png')}
											style={{
												width: '14.5rem',
												height: '23rem',
											}}
											className='m_main_carousel_img'
										/>
									</Col>
									<Col
										lg={8}
										sm={12}
										xs={12}
										className='m_main_box_bottom'>
										<button onClick={joinAction}>
											{
												textData?.mobileMain
													.carousel1_button
											}
										</button>
									</Col>
								</Col>
							</Row>
						</Carousel.Item>
						<Carousel.Item>
							<Row className='m_main_box2 m_main_box'>
								<Col lg={12} className='m_main_box_text'>
									{lang === 'ko' ? (
										<Col>
											<p>
												{
													textData?.mobileMain
														.carousel2_subText
												}
											</p>
										</Col>
									) : null}
									<Col>
										<h1>
											{
												textData?.mobileMain
													.carousel2_mainText1
											}
										</h1>
										<h1>
											{
												textData?.mobileMain
													.carousel2_mainText2
											}
										</h1>
									</Col>
									{lang === 'en' ? (
										<Col>
											<p
												style={{
													fontSize: '1.6rem',
													textAlign: 'center',
													marginTop: '0.5rem',
												}}>
												NFTs with Amazing benefits
											</p>
										</Col>
									) : null}
									<Col
										lg={12}
										sm={12}
										xs={12}
										className='my-5 m_main_box_bottom'>
										<img
											src={require('../../assets/mobile_assets/tori_new.png')}
											style={{
												width: '25rem',
												height: '25rem',
											}}
											className='m_main_carousel_img'
										/>
									</Col>
									<Col
										lg={12}
										sm={12}
										xs={12}
										className='m_main_box_bottom'>
										<button
											style={{
												width:
													lang === 'ko'
														? '14.4rem'
														: '17.1rem',
											}}
											onClick={() =>
												history.push({
													pathname: '/about',
												})
											}>
											{
												textData?.mobileMain
													.carousel2_button
											}
										</button>
									</Col>
								</Col>
							</Row>
						</Carousel.Item>
					</Carousel>
				</div>
				<Container fluid className='m_main_content_container'>
					<Row className='m_main_vip_content_container'>
						<div className='m_main_utility_text m_main_utility_text1'>
							<h1
								style={{
									textAlign: lang === 'en' ? 'center' : null,
									fontSize: lang === 'en' ? '2rem' : null,
								}}>
								{textData?.mobileMain.vip_mainContent}
							</h1>
						</div>
						<div className='m_main_utility_box'>
							<Col className='m_main_utility_top'>
								<Col>
									<p
										style={{
											fontSize:
												lang === 'en' ? '1.1rem' : null,
											marginBottom:
												lang === 'en' ? '0.6rem' : null,
										}}>
										{textData?.mobileMain.vip_subText}
									</p>
									<h1
										style={{
											fontSize:
												lang === 'en' ? '1.1rem' : null,
										}}>
										{textData?.mobileMain.vip_mainText}
									</h1>
								</Col>
								<Col className='m_main_utility_bottom'>
									{/* <a href="#membership_gift"> */}
									<button
										style={{
											width:
												lang === 'en'
													? '11.8rem'
													: null,
											fontWeight:
												lang === 'ko' ? '700' : '400',
										}}
										onClick={() => onModal('Shilla')}>
										{textData?.mobileMain.vip_button}&nbsp;
										{lang === 'ko' ? '>' : null}
									</button>
									{/* </a> */}
								</Col>
							</Col>
							<div className='m_main_vip_card_container'>
								<img
									src={require('../../assets/mobile_assets/vip_card.png')}
									className='m_main_vip_card_img'
									style={{ width: '9.3rem', height: '100%' }}
								/>
								{/* <Col className="m_main_utility_image_container"></Col> */}
							</div>
						</div>
					</Row>
					<div style={{ padding: '0 2.6rem', marginTop: '9.8rem' }}>
						<Col
							lg={12}
							className='m_main_utility_text'
							id='membership_gift'
							style={{ marginBottom: '3.2rem' }}>
							<h1>
								{textData?.mobileMain.membership_info_content1}
							</h1>
							<h1>
								{textData?.mobileMain.membership_info_content2}
							</h1>
						</Col>
						{lang === 'ko'
							? textData?.mobileMembershipContent.content.map(
									(item, index) => {
										return (
											<Row
												className='m_main_membership_gift'
												key={index}>
												<div
													className='m_main_membership_gift_content'
													style={{
														padding: '0',
														width:
															index === 1
																? '63%'
																: '70%',
													}}>
													{item.mainText
														.split('\n')
														.map((it, index) => {
															return (
																<h1 key={index}>
																	{it}
																</h1>
															);
														})}
													{item.subText
														.split('\n')
														.map((it, index) => {
															return (
																<p key={index}>
																	{it}
																</p>
															);
														})}
												</div>
												<div
													className=''
													style={{
														padding: '0',
														width:
															index === 1
																? '37%'
																: '30%',
													}}>
													<img
														src={require(`../../assets/mobile_assets/membership_${item.id}.png`)}
														className={
															index === 1
																? 'm_main_membership_item_image1'
																: 'm_main_membership_item_image'
														}
														// style={{ width : index === 1 ? "10.5rem" : "8.5rem"}}
													/>
												</div>
											</Row>
										);
									}
							  )
							: textData?.mobileMembershipContent.content.map(
									(item, index) => {
										return (
											<Row
												lg={12}
												md={12}
												xs={12}
												className='m_main_membership_gift'
												key={item.index}>
												<Col
													lg={12}
													md={12}
													xs={12}
													style={{
														display: 'flex',
														justifyContent:
															'flex-end',
													}}>
													<img
														src={require(`../../assets/mobile_assets/membership_${item.id}.png`)}
														className='m_main_membership_item_image'
														style={{
															width:
																index === 1
																	? '10.5rem'
																	: '8.5rem',
														}}
													/>
												</Col>
												<Col
													lg={12}
													md={12}
													xs={12}
													className='m_main_membership_gift_content'>
													{item.mainText
														.split('\n')
														.map((it, index) => {
															return (
																<h1 key={index}>
																	{it}
																</h1>
															);
														})}
													{item.subText
														.split('\n')
														.map((it, index) => {
															return (
																<p key={index}>
																	{it}
																</p>
															);
														})}
												</Col>
											</Row>
										);
									}
							  )}
					</div>
					<Row
						style={{ padding: '0 2.6rem', margin: '0' }}
						className='m_main_utility_text_box'>
						<Col className='m_main_utility_text'>
							<h1>
								{textData?.mobileMain.membership_level_mainText}
							</h1>
						</Col>
						<Col className='m_main_partners_content'>
							{lang === 'en' ? (
								<p>
									Konnect Membership is classified into
									<br />
									<b>‘tier-rated for one year’</b> for
									convenience and benefits. Check below for
									details.
								</p>
							) : (
								<p>
									커넥트 멤버십은 고객 여러분의 편의와 더 많은
									혜택을 위해{' '}
									<b>'일 년간 티어 등급으로 운영'</b> 됩니다.
									자세한 사항은 아래 내용을 확인 해주세요
								</p>
							)}
						</Col>
					</Row>
					<div className='m_main_tier_box'>
						<Col className='m_main_tiet_main_content_box'>
							<h1
								className='m_main_tier_main_content'
								style={{ color: '#000000' }}>
								{textData?.mobileMain.membership_level_subText}
							</h1>
						</Col>
						<div className='m_main_tier_standard'>
							{membershipStandard
								.map((item, index) => {
									return (
										<div
											className='m_main_tier_standard_list'
											key={index}>
											<Col
												lg={2}
												md={2}
												sm={2}
												xs={2}
												style={{
													margin: '0',
													padding: '0',
												}}>
												<Image
													src={item.img}
													fluid
													style={{
														width: '2.4rem',
														height: '2.4rem',
													}}
												/>
											</Col>
											<Col
												lg={5}
												md={5}
												sm={5}
												xs={5}
												style={{
													margin: '0',
													padding: '0',
												}}
												className='m_main_tier_standard_level'>
												<h3>
													{item.level.toLocaleUpperCase()}
												</h3>
											</Col>

											<Col
												lg={5}
												md={5}
												sm={5}
												xs={5}
												style={{
													margin: '0',
													padding: '0',
												}}
												className='m_main_tier_standard_price'>
												<Col className='m_main_tier_standard_price'>
													<h2>{item.usdt} USDT</h2>
													{/* <p>
														(
														{(item.kct).toFixed(0)}{' '}KCT)
													</p> */}
												</Col>
											</Col>
										</div>
									);
								})
								.reverse()}
						</div>
					</div>
					<div className='m_main_tier_box_container'>
						<div>
							<h1 className='m_main_tier_main_content'>
								{textData?.mobileMain.tier_level_mainText}
							</h1>
						</div>
						<div className='m_main_devide_tier_box'>
							<div className='m_main_tier_level_box'>
								<Col
									lg={12}
									sm={12}
									xs={12}
									className='m_main_tier_main_text'>
									<h1 className='m_main_tier_text'>TIER 1</h1>
								</Col>
								<Stack
									lg={12}
									sm={12}
									xs={12}
									gab={5}
									className='m_main_tier_detail_list'>
									{tier1
										.map((item, index) => {
											return (
												<div
													lg={12}
													sm={12}
													xs={12}
													className='m_main_tier_detail_box'
													key={index}>
													<div
														lg={3}
														sm={3}
														xs={4}
														className='m_main_tier_image_box'>
														<Image
															src={item.img}
															style={{
																width: '2.4rem',
																height: '2.4rem',
															}}
														/>
													</div>
													<div
														lg={9}
														sm={9}
														xs={8}
														className='m_main_tier_detail_text'>
														<h1 className='m_main_tier_level_content'>
															{item.level.toLocaleUpperCase()}
														</h1>
													</div>
												</div>
											);
										})
										.reverse()}
								</Stack>
								<div
									lg={10}
									sm={10}
									xs={10}
									className='m_main_tier_usdt_about'>
									<p>10,000 USDT</p>
								</div>
							</div>
							<div className='m_main_tier_level_box'>
								<div className='m_main_tier_main_text'>
									<h1 className='m_main_tier_text'>TIER 2</h1>
								</div>
								<Stack
									lg={12}
									sm={12}
									xs={12}
									gab={5}
									className='m_main_tier_detail_list'>
									{tier2
										.map((item, index) => {
											return (
												<div
													lg={12}
													sm={12}
													xs={12}
													className='m_main_tier_detail_box'
													key={index}>
													<div
														lg={3}
														sm={3}
														xs={4}
														className='m_main_tier_image_box'>
														<Image
															src={item.img}
															fluid
															style={{
																width: '2.4rem',
																height: '2.4rem',
															}}
														/>
													</div>
													<div
														lg={9}
														sm={9}
														xs={8}
														className='m_main_tier_detail_text'>
														<h1 className='m_main_tier_level_content'>
															{item.level.toLocaleUpperCase()}
														</h1>
													</div>
												</div>
											);
										})
										.reverse()}
								</Stack>
								<Col
									lg={10}
									sm={10}
									xs={10}
									className='m_main_tier_usdt_about'>
									<p>100 USDT</p>
								</Col>
							</div>
						</div>
						2
					</div>
					<Row style={{ padding: '0 2.6rem', margin: '0' }}>
						{textData?.mobileTierDescription.content.map(
							(item, index) => {
								return (
									<Row
										className='m_main_tier_level_cutline'
										key={index}>
										<Col>
											<h1 style={{ fontWeight: '700' }}>
												{item.main_text}
											</h1>
										</Col>
										<Stack gap={2}>
											{item.category.map((it, index) => {
												return (
													<p
														style={{
															fontWeight: '400',
														}}
														key={index}>
														{it}
													</p>
												);
											})}
										</Stack>
									</Row>
								);
							}
						)}
					</Row>
					<Row className='m_main_membership_about'>
						<Col lg={12} sm={12} xs={12}>
							<h1>{textData?.mobileMain.easy_using_mainText}</h1>
						</Col>
						<Col
							lg={12}
							sm={12}
							xs={12}
							className='m_main_membership_image_box'>
							<Image
								src={require('../../assets/mobile_assets/all_card.png')}
								fluid
								width={'80%'}
								height={'70%'}
								className='m_main_all_card_image'
							/>
						</Col>
						<Col lg={12} sm={12} xs={12}>
							{lang === 'en' ? (
								<p>
									Anytime, anywhere
									<br />
									From sign up to use, check at a glance
									<br />
									Use it conveniently
								</p>
							) : (
								<p>
									언제 어디서나 간편하게
									<br />
									가입부터 사용까지, 한눈에 확인하시고
									<br />
									편하게 사용하세요
								</p>
							)}
						</Col>
					</Row>
					{/* <div ref={whiteAreaRef} className="whiteArea"> */}
					{membershipContent.map((it, index) => {
						return (
							<Row className='m_main_membership_step' key={it.id}>
								<Col
									lg={3}
									sm={3}
									xs={3}
									className='m_main_step_text'>
									<p>STEP 0{it.id}</p>
								</Col>
								<Col
									lg={12}
									sm={12}
									xs={12}
									style={{ marginTop: '1.5rem' }}>
									<h1>{it.mainText}</h1>
								</Col>
								<Row
									lg={12}
									sm={12}
									xs={12}
									className='m_main_step_box'>
									<Col
										className='m_main_step_image'
										style={{
											marginTop:
												it.id > 1 ? '3.7rem' : '0',
										}}>
										<img
											src={require(`../../assets/mobile_assets/menu_${it.id}.png`)}
											className='m_main_menu_image'
											style={{ width: '17.6rem' }}
										/>
									</Col>
									<Col>
										{it.subText
											.split('\n')
											.map((content, index) => {
												return (
													<h3 key={index}>
														{content}
													</h3>
												);
											})}
									</Col>
								</Row>
							</Row>
						);
					})}
					{/* </div> */}
				</Container>
			</Container>
			<Footer />
		</>
	);
};

export default M_newMain;
